// used for blocking a section of content while ajax is loading...

bq.grid = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.$listing  = false;
  this.$grid     = false;
  this.currentPage = 1;
  this.searchTerm = false;
  this.searchBox = false;
  this.perPage = false;
  this.advancedSearch = false;
  this.activeFilters = false; //type, value, display
  this.activeFiltersParams = false;
  this.activeFiltersCache = {};
};

bq.grid.updateRowColors = function(table) {
  var isNewDesign = $('body').is('.theme-new, .light-theme, .dark-theme');
  if (!isNewDesign) {
    return;
  }

  var $table = $(table);
  if (!$table.length) {
    return;
  }

  $table.find('tbody > tr.grid-row').each(function(index, row) {
    var trStripedClass = index % 2 === 0 ? 'tr-striped-color-grey' : 'tr-striped-color-white';
    this.style.backgroundColor = '';
    $(row).removeClass('tr-striped-color-grey', 'tr-striped-color-white');
    $(row).addClass(trStripedClass);
  });
};

bq.grid.DEFAULTS = {
  perPage: 10,
  ajaxUrl: '',
  totalResults: false,
  listingContainer: '.listing-container',
  listingHolder: '.grid table[data-grid] > tbody',
  gridTable: 'table',
  templateTarget: '.grid-row',
  paginationContainer: '.do-pagination',
  currentPage: 1,
  sort: '',
  sortDir: '',
  defaultSortDir: 'desc',
  sortAscMessage: 'Sort column in ascending order',
  sortDescMessage: 'Sort column in descending order',
  sortTooltip: false,
  filterContainer: '.grid-filter-container',
  clearText: bq.messages.global.clearAll,
  errorTemplate: '<tr><td colspan="%cols%"><div class="alert alert-warning">%error%</div></td></tr>',
  clearProcess: false,
  filterBox: '.filter-box'
};

bq.grid.prototype = {
  init: function() {
    var storageData = localStorage.getItem(this.$element.attr('id'));
    if (storageData) {
        this.activeFiltersCache = JSON.parse(storageData);
        if (this.activeFiltersCache['search_string']) {
            this.searchTerm = this.activeFiltersCache['search_string'];
        }
    }

    this.$grid = $(this.options.gridTable, this.$element);
    this.$listing = $(this.options.listingContainer, this.$element);

    this.currentPage = this.options.currentPage;
    this.perPage = this.options.perPage;

    //is quick search available?
    var tmpSearchBox = $('[data-search="true"]', this.$element);
    if(tmpSearchBox.length > 0) {
      this.searchBox = tmpSearchBox;
      this.searchBox.on('keyup', {thiz:this}, this._catchSearchKeyEvent);

      $('[data-search-button="true"]', this.$element).on('click', {thiz:this}, this._catchSearchButtonClickEvent);
      if (this.searchTerm) {
          this.searchBox.val(this.searchTerm);
      }
      //add event for btn?

    }

    //is per page available?
    var tmpPerPageBox = $('[data-per-page="true"]', this.$element);
    if(tmpPerPageBox.length > 0) {
      tmpPerPageBox.on('change', {thiz:this}, this._catchPerPageBoxChangeEvent);
    } else {
      var tmpPerPageList = $('[data-per-page]', this.$element);
      if (tmpPerPageList.length > 0) {
        tmpPerPageList.on('click', {thiz:this}, this._catchPerPageListChangeEvent);
      }
    }

    //is advanced search available?
    var tmpAdvancedSearch = $('[data-search-advanced="true"]', this.$element);
    if(tmpAdvancedSearch.length > 0) {
      this.advancedSearch = tmpAdvancedSearch;
      this.advancedSearch.on('click', 'button', {thiz:this}, this._catchAdvancedSearchClickEvent);
      this._updateCurrentFilters();
    }

    var tmpDownloadButton = $('[data-download="true"]', this.$element);
    if(tmpDownloadButton.length > 1) {
      tmpDownloadButton.on('click', {thiz:this}, this._catchDownloadClickEvent);
    }

    var filter = $('.filter-form-wrapper', this.$element);
    var $this = this;
    if (filter.length > 0) {
	    filter.each(function(){
		    if ($(this).find('.filter-with-button').length > 0) {
			    $(this).on('click', '.filter-action-button a', {thiz: $this}, $this._catchFilterChangedEvent);
		    } else {
			    $(this).on('change', {thiz: $this}, $this._catchFilterChangedEvent);
		    }
      });
    }

    this._setParams();

    this.$listing.on('bq.pagination.changed', {thiz: this}, this._catchEventPageChanged);
    this.$listing.on('bq.grid.changed', {thiz: this}, this._catchReloadGridEvent);
    this.$listing.on('bq.domUpdated', {thiz: this}, this._catchDomUpdatedEvent);

    this.errorTemplate = this.options.errorTemplate.replace('%cols%', $(this.$grid.find(this.options.templateTarget)[0]).find('td').length);

    this.$listing.itemListingLoader({
      ajaxUrl: this.options.ajaxUrl,
      maxResults: this.options.perPage,
      perPage: this.options.perPage,
      totalResults: this.options.totalResults,
      listingHolder: this.options.listingHolder,
      templateTarget: this.options.templateTarget,
      totalLoaded: this.options.totalLoaded,
      paginationContainer: this.options.paginationContainer,
      showItemStatus: this.options.showItemStatus !== undefined ? this.options.showItemStatus : true,
      errorTemplate: this.errorTemplate
    });

    if($(this.options.filterContainer).length >= 1) {
      $(this.options.filterContainer).on('click', 'a', {thiz:this}, this._catchCurrentFilterClick);
      this._fillPreviousFilters();
      this._updateCurrentFilters();
      this._createCurrentFilters();
    }

    this._initSorting();
    this._initDownloads();
    bq.grid.updateRowColors(this.$grid);
    if (this.activeFilters) {
      this._setParams();

      //hack to get advanced to close
      var tmpAdvancedButton = $('[data-bq="collapse"]', this.$element);
      if (tmpAdvancedButton.length >= 1 & !tmpAdvancedButton.hasClass('collapsed-bq')) {
          tmpAdvancedButton.click();
      }

      this._createCurrentFilters();
    }
  },

  _fillPreviousFilters: function(){
      var $this = this;
    var _fields = $('.filter-list-container').find('input, select');

    _fields.each(function(i, el) {
      if ($this.activeFiltersCache[el.name]) {
        if ($(el).data('select2')) {
          var select2Data = '';

          if (Array.isArray($this.activeFiltersCache[el.name]) && !$(el).attr('multiple')) {
            select2Data = $this.activeFiltersCache[el.name][0];
          } else {
            select2Data = $this.activeFiltersCache[el.name];
          }

          $('[name="' + el.name + '"]').select2('data', select2Data);

        } else {
          $('[name="' + el.name + '"]').val($this.activeFiltersCache[el.name]);
        }
      }
    });
  },

  _initSorting: function() {
    var sortables = $('[data-sort="true"]', this.$grid);
    var $this = this;

    sortables.each(function() {
      $this._createSortableLink(this);
    });

    this._resetSortInformation(false);
  },

  _createSortableLink: function(th) {
    th = $(th);
    var oldHeader = th.html();

    if(th.find('a').length > 0) { return; } //already contains a link
    //bug in bootstrap tooltip requires me to hardcode container here
    if (th.data('idPrefix')) {
        var newHtml = $('<a id="' + th.data('idPrefix') + '" href="javascript:void(0);" data-container="body"></a>').html(oldHeader);
    } else {
        var newHtml = $('<a href="javascript:void(0);" data-container="body"></a>').html(oldHeader);
    }

    th.html(newHtml);

    th.find('a').on('click', {thiz:this}, this._catchEventSort);
  },

  _resetSortInformation: function(active) { //pass TH object
    if(active) {
      //clear everything else, set this ones sort direction
      var ths = $('th[data-sort="true"]', this.$grid);
      var dir = this.options.defaultSortDir;
      //if active already has a sort direction, flip it
      if($(active).attr('data-sort-dir')) { dir = ($(active).attr('data-sort-dir') == 'asc') ? 'desc' : 'asc'; }
      ths.removeAttr('data-sort-dir');
      $(active).attr('data-sort-dir', dir);
    }

    var sortables = $('th[data-sort="true"] a', this.$grid);
    var $this = this;

    if(this.options.sortTooltip) {

      sortables.each(function() {
        var th = $(this).closest('th');
        var msg = ($this.options.defaultSortDir == 'asc') ? $this.options.sortAscMessage : $this.options.sortDescMessage;

        if(th.data('sortDir')) {
          msg = (th.data('sortDir') == 'asc') ? $this.options.sortDescMessage : $this.options.sortAscMessage;
        }

        bq.helper.updateTooltip(this, msg, {'container': 'body'});

      });
    }


  },

  _updateGrid: function() {
    this._setParams();

    //hack to get advanced to close
    var tmpAdvancedButton = $('[data-bq="collapse"]', this.$element);
    if(tmpAdvancedButton.length >= 1 & !tmpAdvancedButton.hasClass('collapsed-bq')) {
      tmpAdvancedButton.click();
    }
    jQuery('tr[id*=progress-details]').each(function() {
        jQuery(this).remove();
    });

    this._createCurrentFilters();
    this._throwEventUpdateGrid();
  },

  _setParams: function() {

    var params = {"grid_name": this.$grid.data('gridName')},
        sort = this.options.sort,
        sortDir = this.options.sortDir,
        active = $('th[data-sort-dir]', this.$grid);

    if(active.length == 1) {
      sortDir = active.attr('data-sort-dir');
      sort = active.attr('data-sort-id');
    }

    params[this.$grid.data('grid')] = {};

    params[this.$grid.data('grid')][this.$grid.data('gridName')] = {
     "current_page": this.currentPage,
     "ajax_request": true,
     "sorted_column": sort,
     "sort_direction": sortDir,
     "current_show_per_page": this.perPage
    };

    if(this.searchTerm) {
      params[this.$grid.data('grid')][this.$grid.data('gridName')]['search_string'] = this.searchTerm;
    }

    if(this.perPage != this.options.perPage) {
      //current_show_per_page
      this.$listing.data('perPage', this.perPage);
      this.options.perPage = this.perPage;
    }


    if(this.activeFiltersParams) {
        params[this.$grid.data('grid')][this.$grid.data('gridName')]['search'] = this.activeFiltersParams['query'];

    }

    this.$listing.data('ajaxParams', params);

  },

  _createCurrentFilters: function() {
    var html = $(),
        validData = false,
        list = $('<ul></ul>', {'class': 'list-unstyled list-inline list-tags'});

    if(this.searchTerm) {
      validData = true;
      var label = '';
      if(this.searchBox.closest('.input-group').find('label').length > 0) {
        label = this.searchBox.closest('.input-group').find('label').text()+': ';
      }

      list.append($('<li></li>')
                    .append($('<a></a>',{
                      'class': 'label label-default label-remove',
                      'data-type': 'search'
                    }).text(label+this.searchTerm)
                  )
                );
    }

    if(this.activeFilters && this.activeFilters.length >= 1) {
      validData = true;
      $.each(this.activeFilters, function() {
        list.append($('<li></li>')
            .append($('<a></a>',{
              'class': 'label label-default label-remove',
              'data-name': this.name,
              'data-value': this.value,
              'data-type': this.type
            }).text(this.display)
          )
        );
      });
    }

    if(validData) {
      if(list.find('li').length >= 2) {
        list.append($('<li></li>')
                    .append($('<a></a>',{
                      'class': 'label label-clear label-remove',
                      'data-type': 'clear'
                    }).text(this.options.clearText)
                  )
                );
      }

      var headerLabel = $(this.options.filterContainer).data('label');
      if(headerLabel) {
        html = html.add($('<span></span>').html(headerLabel));
      }

      html = html.add(list);
    }

    $(this.options.filterContainer).html(html);

  },

  _updateCurrentFilters: function(clear) {

    var active = [], self = this;

    if (this.advancedSearch) {
        this.advancedSearch.find(":input:not([type=hidden])").each(function(){
            var $this = $(this);

            if(clear) {
	              self.options.clearProcess = true;
	              $this.val('').trigger("change");
	              if(!$this.is('input')) {
                    // its a select box
                    $this.find('option').removeAttr("selected").trigger("change");
	              }
	              self.options.clearProcess = false;
            }

            var label = $this.closest('.form-group').find('label');

            if($this.val() && !label.data('isShown')) {
                var display = '';
                var isGroup = false;

                if(label.length == 1) {

                    if($this.closest('.form-group').find('.input-daterange').length) {
                        display = label;
                        isGroup = true;
                    }
                    display = label.text()+': ';
                }

                if(!$this.is('input') && !($this.is('select') && $this.data('select2'))) {

                    // its a select box
                    var selections = $this.find('option').filter(':selected');
                    if (selections.length) {
                        var selectedVals = [], selectedValText = [];
                        selections.each(function() {
                            var selected = $(this);
                            active.push({
                                'display': display+selected.text(),
                                'type': 'filter',
                                'name': $this.attr('name'),
                                'value': selected.attr('value')
                            });

                            selectedVals.push(selected.attr('value'));
                            selectedValText.push({text: display+selected.text(), value: selected.attr('value')});
                        });
                        self.activeFiltersCache[$this.attr('name')] = selectedVals;
                        self.activeFiltersCache[$this.attr('name') + '_selectedChoices'] = selectedValText;
                    } else if (!clear) {
                        var cacheSelections = self.activeFiltersCache[$this.attr('name') + '_selectedChoices'];
                        if (Array.isArray(cacheSelections) && cacheSelections.length) {
                            $.each(cacheSelections, function(i, e) {
                                active.push({
                                    'display': e.text,
                                    'type': 'filter',
                                    'name': $this.attr('name'),
                                    'value': e.value
                                });
                            });
                        }
                    }
                } else if ($this.attr('multiple') && $this.data('select2')) {
                    var selectedVals = $this.data('select2').data() ? $this.data('select2').data() : $this.val();

                    if (Array.isArray(selectedVals) && !selectedVals.length) {
                        var previousSelectedChoices = self.activeFiltersCache[$this.attr('name') + '_selectedChoices'];

                        if (Array.isArray(previousSelectedChoices) && previousSelectedChoices.length) {
                            $this.select2('data', previousSelectedChoices);
                            selectedVals = previousSelectedChoices;
                            delete self.activeFiltersCache[$this.attr('name') + '_selectedChoices'];
                        }
                    }

                    var supplierIds = [];
                    var supplierIdsWithText = [];
                    $(selectedVals).each(function(index, element) {
                        active.push({
                            'display': element.text,
                            'type': 'filter',
                            'name':$this.attr('name'),
                            'value':element.id
                        });
                        supplierIds.push(element.id);
                        supplierIdsWithText.push({ id: element.id, text: element.text, disabled: false });
                    });

                    self.activeFiltersCache[$this.attr('name')] = supplierIdsWithText;
                    self.activeFiltersCache[$this.attr('name') + '_selectedChoices'] = supplierIdsWithText;
                } else if ($this.attr('name')) {

                    if ($this.data('select2')) {
                        var val = $this.select2('data') ? $this.select2('data').text : $this.val();
                        display = display + val;

                        var previousSelectedChoices = self.activeFiltersCache[$this.attr('name') + '_selectedChoices'];
                        if (Array.isArray(previousSelectedChoices) && previousSelectedChoices.length) {
                            if (previousSelectedChoices[0].id == $this.val()) {
                                display = previousSelectedChoices[0].text;
                            }
                        }

                        active.push({
                            'display': display,
                            'type': 'filter',
                            'name': $this.attr('name'),
                            'value': $this.val()
                        });
                        var valArray = [];
                        valArray.push({id: $this.val(), text: display, disabled: false});
                        self.activeFiltersCache[$this.attr('name')] = valArray;
                        self.activeFiltersCache[$this.attr('name') + '_selectedChoices'] = valArray;
                    }  else {

                        if (isGroup) {
                            var divider = $($this.closest('.form-group').find('.input-group-addon')[0]).text();
                            var tmpDisplayValues = [];

                            if (!divider) {
                                divider = ' &amp; ';
                            }

                            $this.closest('.form-group').find('input').each(function () {
                                if ($(this).val() !== '') {
                                    tmpDisplayValues.push($(this).val());
                                }
                            });

                            display = display + tmpDisplayValues.join(divider);

                            label.data('isShown', true);

                        } else {
                            var val = $this.data('select2') && $this.data('select2').data() ? $this.data('select2').data().text : $this.val();
                            // fix text value for selectbox
                            $('#' + $this.attr('id') + '_select2').val(val);
                            display = display + val;
                        }
                        //its a textbox/textarea
                        active.push({
                            'display': display,
                            'type': 'filter',
                            'name': $this.attr('name'),
                            'value': $this.val()
                        });
                        self.activeFiltersCache[$this.attr('name')] = $this.val();
                    }
                }
            } else if (!$this.val() && $this.attr('multiple') && $this.data('select2')) {
              setTimeout(function(){
                $this.select2("close");
              }, 1);
            }
        });
        this.activeFiltersParams = bq.helper.formToObject(this.advancedSearch);
        this.advancedSearch.find('label').data('isShown', false);
    }

    if(active.length >= 1) {
      this.activeFilters = active;
    } else {
      this.activeFilters = false;
    }

    localStorage.setItem(this.$element.attr('id'), JSON.stringify(this.activeFiltersCache));
	  this._hideFilters();
  },

  _removeFilter: function(el) {
    switch(el.data('type')) {
      case 'search': //clearing search term
        this.searchTerm = false;
        this.searchBox.val('');
        this._updateGrid();

        this.activeFiltersCache['search_string'] = '';
        localStorage.setItem(this.$element.attr('id'), JSON.stringify(this.activeFiltersCache));
        break;
      case 'clear':
        this._clearAllFilters();
        this._updateGrid();
        localStorage.removeItem(this.$element.attr('id'));
        this.activeFiltersCache = {};
        break;
      case 'filter':
        var input = $('[name="'+el.data('name')+'"]');
        if(input) {
          var canClearSelect2 = true;
          var v = el.data('value');

          if (v && $(input).attr('multiple') && $(input).data('select2')) {
              var active = [];
              var currentValues = $(input).data('select2').data();
              $(currentValues).each(function(index, element) {
                  if (element.id != v)
                      active.push(element);
              });
              input.select2('data', active, true);
              this.activeFiltersCache[input.attr('name') + '_selectedChoices'] = input.data('select2').data();
              this.activeFiltersCache[input.attr('name')] = input.val();
              canClearSelect2 = false;
          } else {
              if (!input.is('input')) {
                  input.find('[value="'+v+'"]').removeAttr("selected");
                  input.trigger('change');
	                delete this.activeFiltersCache[input.attr('name')];
              } else if (input.closest('.form-group').find('.input-daterange').length) {
                  input.closest('.form-group').find('input').val('');
                  // clear supplier selectbox
                  input.select2('val', '');
              } else {
                  input.val('');
	                delete this.activeFiltersCache[input.attr('name')];
              }
          }

          this._updateCurrentFilters();
          this._updateGrid();
          if (canClearSelect2) {
            input.select2('data', null);
          }
        }
        break;
      default:
        break;
    }

    return;
  },

  _clearAllFilters: function() {
    if(this.searchBox) {
      this.searchTerm = '';
      this.searchBox.val('');
    }

    if(this.advancedSearch) {
      this._updateCurrentFilters(true);
    }

  },

  _catchDownloadClickEvent: function(e) {
      if (!e.data.url) {
          return ;
      }
      var url = e.data.url;
      var $this = e.data.thiz;

      $this._setParams();
      //generate fake element
      var el = $("<input type='hidden' name='parameters' />");
      $(el).val(JSON.stringify($this.$listing.data('ajaxParams')));
      //generate fake form and submit it
      var form = $("<form style='display: none;'></form>");

      $(form).attr('action', url)
        .attr('method', 'POST')
        .attr('target', '_blank')
        .append($(el));

      $('body').append($(form));
      $(form).submit().remove();
  },

  _catchCurrentFilterClick: function(e) {
    var $this = e.data.thiz;
    $this.currentPage = 1; //reset current page so it clears grid, starts over
    $this._removeFilter($(e.target));
    return false;
  },

  _catchEventSort: function(e) {
    var $this = e.data.thiz;
    var th = $(this).closest('th');

    $this._resetSortInformation(th);
    $this.currentPage = 1; //reset current page so it clears grid, starts over
    $this._updateGrid();

  },

  _catchEventPageChanged: function(e, oldEvent, oldPage, newPage) {
    var $this = e.data.thiz;

    if($this.currentPage == newPage) { return; } //already here

    $this.currentPage = newPage;
    $this._setParams();

  },

  _catchReloadGridEvent: function(e) {
      e.preventDefault();
      var $this = e.data.thiz;

      $this.currentPage = 1;
      $this._updateGrid();
  },

  _catchDomUpdatedEvent: function(e) {
    var $this = e.data.thiz;
    bq.grid.updateRowColors($this.$grid);
  },

  _catchSearchButtonClickEvent: function(e) {
    var $this = e.data.thiz;
    var val = $this.searchBox.val();

    if(val != $this.searchTerm) {
      e.preventDefault();
      $this.currentPage = 1; //reset current page so it clears grid, starts over
      $this.searchTerm = val;
      $this.activeFiltersCache['search_string'] = val;
      jQuery('#messages-bar').empty();
      $this._updateGrid();
      localStorage.setItem($this.$element.attr('id'), JSON.stringify($this.activeFiltersCache));
    }
  },

  _catchSearchKeyEvent: function(e) {
    var $this = e.data.thiz;
    var val = $(e.target).val();

    if(e.which==13 && val != $this.searchTerm) {
      e.preventDefault();
      $this.currentPage = 1; //reset current page so it clears grid, starts over
      $this.searchTerm = val;
      $this.activeFiltersCache['search_string'] = val;
      jQuery('#messages-bar').empty();
      $this._updateGrid();
      localStorage.setItem($this.$element.attr('id'), JSON.stringify($this.activeFiltersCache));
    }
  },

	_catchFilterChangedEvent: function(e) {
    var $this = e.data.thiz;
    if (!$this.options.clearProcess) {
      if($($this.advancedSearch).parsley().validate()) {

        var val = $this.searchBox.val();
        if(val != $this.searchTerm) {
          $this.searchTerm = val;
        }

        $this._updateCurrentFilters();
        $this.currentPage = 1; //reset current page so it clears grid, starts over

        $this._updateGrid();
      }

      $this._hideFilters();
    }
  },

  _catchPerPageBoxChangeEvent: function(e) {
    var $this = e.data.thiz;
    var val = $(e.target).val();

    if(val != $this.perPage) {
      e.preventDefault();
      $this.currentPage = 1; //reset current page so it clears grid, starts over
      $this.perPage = val;
      $this._updateGrid();
    }
  },

  _catchPerPageListChangeEvent: function(e) {
    e.preventDefault();
    var $this = e.data.thiz;
    var $target = $(e.target);
    var val = $target.data('per-page');

    if(val != $this.perPage) {
      $target.addClass('active').siblings('.active').removeClass('active');
      $this.currentPage = 1; //reset current page so it clears grid, starts over
      $this.perPage = val;
      $this._updateGrid();
    }
  },

  _throwEventUpdateGrid: function() {
    this._hideGridOpenedActionsDropdown();

    //throw event
    bq.helper.throwEvent('bq.itemlisting.update', this.$listing, [{'clear':true}]);
  },

  _hideGridOpenedActionsDropdown: function(){
    if ($('body > .dropdown-menu-wrapper').length > 0) {
	    $('body > .dropdown-menu-wrapper').hide();
	    $('body > .dropdown-menu-wrapper > .dropdown-menu').hide();
    }

    $('body > .dropdown-menu').hide();
  },

  _initDownloads: function() {
    var downloads = $('[data-download="true"]', this.$element);
    if (!downloads.length) {
        return;
    }

    var $this = this;
    downloads.each(function() {
        $this._createDownloadLink(this);
    });

    //catch event of parent saying something has changed
    this.$listing.on('bq.pagination.update.visibility', {thiz: this},  this._catchEventDownloadsUpdate);
  },

  _createDownloadLink: function(a) {
    $(a).on('click', {thiz:this, url: $(a).attr('data-download-url')}, this._catchDownloadClickEvent);
  },

  _catchEventDownloadsUpdate: function(e, hide) {
    var $this = e.data.thiz;
    var downloads = $('[data-download="true"]', this.$element);
    downloads.each(function() {
      if(hide) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  },

  _hideFilters: function() {
	  $(this.options.filterBox).removeClass('active');
  }
};

// GRID PLUGIN DEFINITION
// =======================

var gridold = $.fn.grid;

$.fn.grid = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.grid');
    var options = $.extend({}, bq.grid.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.grid', (data = new bq.grid(this, options))); }
    data.init();
  });
};

$.fn.grid.Constructor = bq.grid;

// GRID NO CONFLICT
// =================

$.fn.grid.noConflict = function () {
  $.fn.grid = gridold;
  return this;
};

// GRID DATA-API
// ==============
bq.gridInit = function() {
  $('[data-bq="grid"]').each(function () {
    var el = $(this);
    if(el.data('bq.grid')) { return; }
    el.grid(el.data());
  });
};

bq.init.push(bq.gridInit);

$j(document).ready(function(){
    $j('[data-grid="buyerquest_grids"] tbody td').each(function(){
        var tdValue = $j.trim($j(this).html());
        if(tdValue === '' || tdValue === '&nbsp;'){
            $j(this).attr('aria-label', bq.messages.global.noValue);
        }
    });
});
